import { useNavigate } from "react-router-dom";
import { HardwireLogo } from "../components/HardwireMark";
import { XCircle, Phone } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-5">
      <div className="w-full max-w-md text-center">
        <div className="mb-6 flex justify-center"><HardwireLogo size={44} /></div>
        <div className="rounded-3xl border border-slate-200 bg-white p-10 shadow-xl" data-testid="payment-cancel">
          <XCircle size={48} className="mx-auto text-slate-400" />
          <h1 className="mt-4 text-2xl font-extrabold text-slate-900">Payment canceled</h1>
          <p className="mt-2 text-slate-500">No charge was made. You can reopen your estimate email to pay the deposit whenever you're ready.</p>
          <div className="mt-6 flex flex-col gap-3">
            <a href="tel:3526153878" className="flex items-center justify-center gap-2 rounded-xl border border-slate-200 py-3 font-semibold text-slate-700 hover:border-[#1286F2] hover:text-[#1286F2]"><Phone size={16} /> 352-615-3878</a>
            <button onClick={() => navigate("/")} className="rounded-xl bg-[#1286F2] py-3 font-bold text-white hover:bg-[#0A84FF]" data-testid="cancel-home-btn">Back to Home</button>
          </div>
        </div>
      </div>
    </div>
  );
}
